module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "news"
  }, [_c('newsletter-modal'), _vm._v(" "), _c('header', {
    staticClass: "heading heading--bg-news heading--desktop",
    class: _vm.page.acf.hero_picture_position,
    style: ({
      'background-image': 'url( ' + _vm.hero_featured_img.source_url + ' )',
    })
  }, [_c('div', {
    staticClass: "container",
    class: [{
      'dark-theme': _vm.page.acf.featured_news_theme == true
    }]
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "date",
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.page.acf.featured_news.post_date))
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.featured_news.post_title)
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.page.acf.featured_news.guid
    },
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.button_label)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-news"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouse-icon-container"
  }, [_c('a', {
    staticClass: "scroll-down-section",
    on: {
      "click": function($event) {
        return _vm.scrollToNextSection()
      }
    }
  }, [_vm._m(0)])])])]), _vm._v(" "), _c('header', {
    staticClass: "heading heading--bg-news heading--mobile",
    class: _vm.page.acf.hero_picture_position,
    style: ({
      'background-image': 'url( ' + _vm.hero_featured_img_mobile + ' )',
    })
  }, [_c('div', {
    staticClass: "container",
    class: [{
      'dark-theme': _vm.page.acf.featured_news_theme == true
    }]
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', {
    staticClass: "date",
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.page.acf.featured_news.post_date))
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.featured_news.post_title)
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.page.acf.featured_news.guid
    },
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.button_label)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bg-news"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouse-icon-container"
  }, [_c('a', {
    staticClass: "scroll-down-section",
    on: {
      "click": function($event) {
        return _vm.scrollToNextSection()
      }
    }
  }, [_vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.news_filter_label)
    }
  }), _vm._v(" "), _c('a', {
    class: ['btn default', {
      active: _vm.catNumber === 0
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.news_all_label)
    },
    on: {
      "click": function($event) {
        return _vm.resetFilter()
      }
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(category, i) {
    return _c('a', {
      key: i,
      class: [
        'btn default',
        category.slug,
        {
          active: _vm.catNumber == category.id
        } ],
      on: {
        "click": function($event) {
          return _vm.loadCategoryPosts(category.id)
        }
      }
    }, [_vm._v(_vm._s(category.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('newsletter-button'), _vm._v(" "), _c('div', {
    staticClass: "row no-margin wrapper"
  }, [_vm._l((_vm.posts), function(post, index) {
    return [(!post.acf.pdf_file) ? _c('div', {
      key: (index + "-x"),
      staticClass: "news-layout-wrapper row-element col-l-12 col-m-12 col-s-12",
      on: {
        "click": _vm.getLastElementPosition
      }
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": {
          path: '/' +
            post.pure_taxonomies.categories[0].slug +
            '/' +
            post.slug,
        }
      }
    }, [_c('div', {
      staticClass: "row no-margin news-layout-item"
    }, [_c('div', {
      staticClass: "image row-element col-l-6 col-m-6 col-s-12"
    }, [(post.better_featured_image && index % 2 == 0) ? _c('div', {
      staticClass: "bg notched notched__enabled notched__inside notched__mobile-outside notched--top notched--mobile-middle notched--white",
      class: post.acf.large_picture_position,
      style: ([
        post.better_featured_image ?
        {
          'background-image': 'url( ' +
            post.better_featured_image.source_url +
            ' )',
        } :
        {} ])
    }, [_c('div', {
      staticClass: "notched-helper"
    })]) : _c('div', {
      staticClass: "bg notched notched__enabled notched__outside notched__mobile-outside notched--top notched--mobile-middle notched--white",
      class: post.acf.large_picture_position,
      style: ([
        post.better_featured_image ?
        {
          'background-image': 'url( ' +
            post.better_featured_image.source_url +
            ' )',
        } :
        {} ])
    }, [_c('div', {
      staticClass: "notched-helper"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "row-element col-l-6 col-m-6 col-s-12"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._l((post.pure_taxonomies
      .categories), function(category, i) {
      return _c('div', {
        key: i,
        class: ['type', category.category_nicename]
      }, [_vm._v("\n                          " + _vm._s(category.name) + "\n                        ")])
    }), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(post.date)))])], 2), _vm._v(" "), _c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    })])])])])], 1) : _vm._e(), _vm._v(" "), (post.acf.pdf_file) ? _c('div', {
      key: (index + "-y"),
      staticClass: "news-layout-wrapper row-element col-l-12 col-m-12 col-s-12",
      on: {
        "click": _vm.getLastElementPosition
      }
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": {
          path: '/' +
            post.pure_taxonomies.categories[0].slug +
            '/' +
            post.slug,
        }
      }
    }, [_c('div', {
      staticClass: "row no-margin news-layout-item"
    }, [_c('div', {
      staticClass: "image row-element col-l-6 col-m-6 col-s-12"
    }, [(post.better_featured_image && index % 2 == 0) ? _c('div', {
      staticClass: "bg notched notched__enabled notched__inside notched__mobile-outside notched--top notched--mobile-middle notched--white",
      class: post.acf.large_picture_position,
      style: ([
        post.better_featured_image ?
        {
          'background-image': 'url( ' +
            post.better_featured_image.source_url +
            ' )',
        } :
        {} ])
    }, [_c('div', {
      staticClass: "notched-helper"
    })]) : _c('div', {
      staticClass: "bg notched notched__enabled notched__outside notched__mobile-outside notched--top notched--mobile-middle notched--white",
      class: post.acf.large_picture_position,
      style: ([
        post.better_featured_image ?
        {
          'background-image': 'url( ' +
            post.better_featured_image.source_url +
            ' )',
        } :
        {} ])
    }, [_c('div', {
      staticClass: "notched-helper"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "row-element col-l-6 col-m-6 col-s-12"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._l((post.pure_taxonomies
      .categories), function(category, i) {
      return _c('div', {
        key: i,
        class: ['type', category.category_nicename]
      }, [_vm._v("\n                          " + _vm._s(category.name) + "\n                        ")])
    }), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(post.date)))])], 2), _vm._v(" "), _c('div', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    })])])])])], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [(!_vm.hideMore) ? _c('a', {
    staticClass: "btn default",
    domProps: {
      "innerHTML": _vm._s(_vm.page.acf.news_show_more_button)
    },
    on: {
      "click": function($event) {
        return _vm.loadMorePosts()
      }
    }
  }) : _vm._e()])], 1)])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mouse-icon"
  }, [_c('span', {
    staticClass: "mouse-wheel"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mouse-icon"
  }, [_c('span', {
    staticClass: "mouse-wheel"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d23d0b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
// module id = 316
// module chunks = 0